import { render, staticRenderFns } from "./Ilmoitustaulu.vue?vue&type=template&id=1bef0342&scoped=true"
import script from "./Ilmoitustaulu.vue?vue&type=script&lang=js"
export * from "./Ilmoitustaulu.vue?vue&type=script&lang=js"
import style0 from "./Ilmoitustaulu.vue?vue&type=style&index=0&id=1bef0342&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bef0342",
  null
  
)

export default component.exports